<template>
  <div class="d-flex" :style="{ padding: '10px' }">
    <v-dialog v-model="dialog" hide-overlay persistent width="300">
      <v-card color="warning" dark>
        <v-card-text>
          Applying change
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card
      class="d-flex pa-2 flex-column"
      :style="{ 'margin-bottom': '40px', width: '100%', height: 'unset' }"
    >
      <div
        :style="{ padding: '25px', paddingBottom: '10px', fontSize: 'small' }"
      >
        <v-row class="align-center" no-gutters>
          <v-col sm="2">Kode Wilayah</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ mappingKodeWilayah }}</v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col sm="2">Branch Code</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ mappingKodeCabang }}</v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col sm="2">Kode Cabang</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ mappingBranchCode }}</v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col sm="2">Nama Cabang</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ mappingNamaCabang }}</v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col sm="2">Kode Pos</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ mappingKodePos }}</v-col>
        </v-row>
        <v-row class="align-center" no-gutters>
          <v-col sm="2">Provinsi</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9">{{ mapingProvinsi }}</v-col>
        </v-row>
        <v-row v-if="disableKodePos" class="align-center" no-gutters>
          <v-col sm="2">Role Type</v-col>
          <v-col sm="1" style="text-align: center">:</v-col>
          <v-col sm="9" class="first-capital">{{ role }}</v-col>
        </v-row>
      </div>
      <div
        class="d-flex pa-2 flex-wrap"
        :style="{ width: '100%', height: '500px' }"
      >
        <div
          class="d-flex pa-2 flex-column"
          :style="{ flex: '5', width: 'inherit' }"
        >
          <v-text-field
            :style="{ flex: '1' }"
            v-model="searchAvailable"
            label="Search for available"
            @input="getListAvailable"
            :loading="loadingSearchAvailable"
          />
          <label for="selectedLeft"></label>
          <select
            v-model="selectedLeft"
            multiple
            class="d-flex pa-2 flex-column"
            :style="{ overflow: 'scroll', flex: '9' }"
            id="selectedLeft"
          >
            <optgroup :label="role" v-if="itemsLeft.length != 0">
              <option
                v-for="(item, i) in itemsLeft"
                :key="i"
                :value="disableKodePos ? item.id : item.zip_code"
              >
                {{ disableKodePos ? item.role_name : item.zip_code }}
              </option>
            </optgroup>
          </select>
        </div>
        <div
          class="d-flex pa-2 flex-column justify-center align-center"
          :style="{ flex: '1' }"
        >
          <v-btn
            color="warning"
            class="mb-2"
            @click="getListDetail"
            :disabled="dialog || loading"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
          <v-btn
            color="red"
            style="color: white"
            class="mb-2"
            @click="toLeft"
            :disabled="dialog || loading"
            ><v-icon>mdi-chevron-double-left</v-icon></v-btn
          >
          <v-btn
            color="success"
            class="mb-2"
            @click="toRight"
            :disabled="dialog || loading"
            ><v-icon>mdi-chevron-double-right</v-icon></v-btn
          >
        </div>
        <div
          class="d-flex pa-2 flex-column"
          :style="{ flex: '5', width: 'inherit' }"
        >
          <v-text-field
            :style="{ flex: '1' }"
            v-model="searchAssigned"
            label="Search for assigned"
            @input="getListAssigned"
            :loading="loadingSearchAssigned"
          />
          <label for="selectedRight"></label>
          <select
            v-model="selectedRight"
            multiple
            class="d-flex pa-2 flex-column"
            :style="{ overflow: 'scroll', flex: '9' }"
            id="selectedRight"
          >
            <optgroup :label="role" v-if="itemsRight.length != 0">
              <option v-for="(item, i) in itemsRight" :key="i" :value="item.id">
                {{ disableKodePos ? item.role_name : item.kodepos }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  data: () => ({
    dialog: false,
    searchAvailable: '',
    searchAssigned: '',
    loadingSearchAvailable: false,
    loadingSearchAssigned: false,
    benched: 0,
    selectedLeft: [],
    selectedRight: [],
  }),
  mounted() {
    if (this.mappingKodeCabang == '') {
      this.$router.push('/rbac-mapping-cabang');
      return;
    }
    this.getListDetail();
  },
  computed: {
    itemsLeft() {
      return this.$store.state.rbac.mappingCabang.available;
    },
    itemsRight() {
      return this.$store.state.rbac.mappingCabang.assigned;
    },
    loading() {
      return this.$store.state.rbac.mappingCabang.loading;
    },
    disableKodePos() {
      return this.$route.params.id == 'kode-pos' ? 0 : 1;
    },
    role() {
      const role = this.$route.params.id.replace('-', ' ');
      return role;
    },
    mappingKodeWilayah() {
      const rtype = this.$store.state.rbac.mappingCabang.detail;
      return rtype == null ? '' : rtype.kode_wilayah;
    },
    mappingKodeCabang() {
      const rtype = this.$store.state.rbac.mappingCabang.detail;
      return rtype == null ? '' : rtype.kode_cabang;
    },
    mappingBranchCode() {
      const rtype = this.$store.state.rbac.mappingCabang.detail;
      return rtype == null ? '' : rtype.branch_code;
    },

    mappingNamaCabang() {
      const rtype = this.$store.state.rbac.mappingCabang.detail;
      return rtype == null ? '' : rtype.nama_cabang;
    },
    mappingKodePos() {
      const rtype = this.$store.state.rbac.mappingCabang.detail;
      return rtype == null ? '' : rtype.kodepos;
    },
    mapingProvinsi() {
      const rtype = this.$store.state.rbac.mappingCabang.detail;
      return rtype == null ? '' : rtype.provinsi;
    },
    roleType() {
      let roleType;
      switch (this.role) {
        case 'inputer':
          roleType = 'inputer';
          break;
        case 'approver':
          roleType = 'approver2';
          break;
        default:
          roleType = '';
      }
      return roleType;
    },
  },
  methods: {
    getListDetail() {
      this.getListAvailable();
      this.getListAssigned();
    },

    getListAvailable() {
      this.loadingSearchAvailable = true;

      const searchAvailable = this.role
        ? { username: this.searchAvailable }
        : {};

      this.$store
        .dispatch('rbac/mappingCabang/fetchAvailable', {
          date,
          role: this.roleType,
          kodeCabang: this.mappingKodeCabang,
          kodePos: this.mappingKodePos,
          search: searchAvailable,
        })
        .then(() => {
          this.loadingSearchAvailable = false;
        });
    },

    getListAssigned() {
      this.loadingSearchAssigned = true;

      const searchAssigned = this.role ? { username: this.searchAssigned } : {};

      this.$store
        .dispatch('rbac/mappingCabang/fetchAssigned', {
          date,
          role: this.roleType,
          kodeCabang: this.mappingKodeCabang,
          kodePos: this.mappingKodePos,
          search: searchAssigned,
        })
        .then(() => {
          this.loadingSearchAssigned = false;
        });
    },

    toRight() {
      if (this.selectedLeft.length > 0) {
        this.dialog = true;
        this.$store
          .dispatch('rbac/mappingCabang/assign', {
            date,
            role: this.roleType,
            id: this.selectedLeft,
            kode_cabang: this.mappingKodeCabang,
            kodePos: this.mappingKodePos,
          })
          .then((res) => {
            if (res) {
              this.getListDetail();
            }
          })
          .finally(() => {
            this.dialog = false;
          });

        this.selectedLeft = [];
        this.selectedRight = [];
      }
    },

    toLeft() {
      if (this.selectedRight.length > 0) {
        this.dialog = true;
        this.$store
          .dispatch('rbac/mappingCabang/revoke', {
            date,
            role: this.roleType,
            id: this.selectedRight,
          })
          .then((res) => {
            if (res) {
              this.getListDetail();
            }
          })
          .finally(() => {
            this.dialog = false;
          });

        this.selectedLeft = [];
        this.selectedRight = [];
      }
    },
  },

  beforeDestroy() {
    this.$store.commit('rbac/mappingCabang/setDetailData', null);
  },
};
</script>

<style scoped>
.first-capital::first-letter {
  text-transform: capitalize;
}
</style>
